import React, { useState, useEffect } from "react";
import { useRoleContext } from "src/hooks/use-alert";
import permissionsJson from "src/permissions.json";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
const theme = createTheme({
  palette: {
    red:  {
      main: '#ff0000',
    },
    yellow:  {
      main: '#f1e022',
      contrastText: '#242105'
    },
    orange: {
      main: '#879a34',
    },
       green: {
      main: '#008000',
    },
    purple: {
      main: '#9f63ec',
    }
  },
});

const ButtonPolicy = (props) => {
  const {
    variant,
    disabled,
    onClick,
    policy,
    className,
    color,
    type,
    sx,
    alarmColor
  } = props;
  const [disabledByPolicy, setDisabledByPolicy] = useState(false);
  const policyName = policy;
  const { roles } = useRoleContext();
  let currentRole = roles;

  useEffect(() => {
    if (policyName) {
      const permissions = permissionsJson;
      //check if the logged user role is authorized ans contained in the permitted roles for this action (property policyName)
      var policyRoles = permissions.Policy.authorizations.find(
        (auth) => auth.name === policyName
      ).roles;
      let unauthorized = true;
      if (currentRole.length === 0) {
        let rolesString = localStorage.getItem("roles");
        currentRole = rolesString === null ? [] : JSON.parse(rolesString);
      }
      currentRole.forEach((r) => {
        let check = policyRoles.includes(r);
        unauthorized = check ? false : true;
      });
      setDisabledByPolicy(unauthorized);
    }
  }, [policyName, currentRole]);

  return (
    <>
    <ThemeProvider theme={theme}>
      <Button
        sx={sx}
        type={type}
        variant={variant}
        disabled={disabled ?? disabledByPolicy}
        onClick={onClick}
        className={className}
        color={color}
      >
        {props.children}
      </Button>
      </ThemeProvider>
    </>
  );
};
export default ButtonPolicy;
